import { useMemo } from 'react';
import { useMasterData } from '../context/MasterDataContext';
import {
  isRefundAllowedForCabang,
  getAllowedRefundCabangIds,
  DEFAULT_REFUND_ALLOWED_CABANG_IDS,
} from '../config/refundConfig';

/**
 * Hook untuk mengecek hak akses menu Pengembalian / Return
 * berdasarkan role user, toko aktif (cabang_id), pengaturan dinamis backend,
 * serta fallback default konfigurasi frontend.
 */
export function useRefundAccess() {
  const masterData = useMasterData() || {};
  const { settings = null, cabangList = [] } = masterData;

  const role = (localStorage.getItem('role') || '').toLowerCase().trim();
  const currentCabangId = localStorage.getItem('cabang_id') || '';
  const currentCabangName = localStorage.getItem('toko') || '';

  const allowedCabangIds = useMemo(() => {
    return getAllowedRefundCabangIds(settings);
  }, [settings]);

  const isRefundAllowed = useMemo(() => {
    return isRefundAllowedForCabang({
      cabangId: currentCabangId,
      cabangName: currentCabangName,
      role,
      settings,
    });
  }, [currentCabangId, currentCabangName, role, settings]);

  return {
    isRefundAllowed,
    allowedCabangIds,
    currentCabangId,
    currentCabangName,
    role,
    cabangList,
    defaultAllowedIds: DEFAULT_REFUND_ALLOWED_CABANG_IDS,
  };
}

export default useRefundAccess;
